import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { GlobalState, GlobalStateModel } from 'src/app/store/states/global.state';
import Widget from 'src/app/models/widget.model';
import Event from 'src/app/models/event.model';
import { ActivatedRoute } from '@angular/router';
import { DatesType } from 'src/app/models/type.definition';

@Component({
  selector: 'app-o-event-infos',
  templateUrl: './o-event-infos.component.html',
  styleUrls: ['./o-event-infos.component.scss']
})
export class OEventInfosComponent implements OnInit, OnDestroy {
  @Select(GlobalState) globalState$: Observable<GlobalStateModel>;
  public event: Event;
  private subscriptions = new Subscription();
  public widget: Widget;
  public dateString: string | null = null;
  public placeString: string | null = null;
  public hideEventInfos: boolean = false;

  constructor(private store: Store, private route: ActivatedRoute) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {

    this.subscriptions.add(this.globalState$.subscribe((state: GlobalStateModel) => {
      this.event = state?.globalObject?.eventId
      this.widget = state?.globalObject?.widget;
      this.hideEventInfos = state?.globalObject?.hideEventInfos;
      if (this.event && this.event.dates.type === DatesType.interval) {
        const startDate = new Date(this.event.dates.startDate);
        const endDate = this.event.dates.endDate ? new Date(this.event.dates.endDate) : null;
        this.dateString = this.formatEventDate(startDate, endDate);
      }
      if (this.event && this.event.place && this.event.place.length > 0) {
        this.placeString = this.event.place[0].city;
      }
      if (this.event) {
        console.log("Categories", this.event.categoriesIds);
      }
    }));
  }

  private formatEventDate(startDate: Date, endDate?: Date | null): string {
    const optionsDate: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'long', year: 'numeric' };
    const optionsDay: Intl.DateTimeFormatOptions = { day: '2-digit' };
    const optionsMonthYear: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
    const optionsTime: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

    const startDay = startDate.toLocaleDateString('fr-FR', optionsDay);
    const startMonthYear = startDate.toLocaleDateString('fr-FR', optionsMonthYear);
    const startTime = startDate.toLocaleTimeString('fr-FR', optionsTime);

    if (!endDate) {
      return `Le ${startDay} ${startMonthYear} à ${startTime}`;
    }

    const endDay = endDate.toLocaleDateString('fr-FR', optionsDay);
    const endMonthYear = endDate.toLocaleDateString('fr-FR', optionsMonthYear);
    const endTime = endDate.toLocaleTimeString('fr-FR', optionsTime);

    // Même jour
    if (
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth() &&
      startDate.getDate() === endDate.getDate()
    ) {
      return `Le ${startDay} ${startMonthYear} de ${startTime} à ${endTime}`;
    }

    // Même mois et année
    if (
      startDate.getFullYear() === endDate.getFullYear() &&
      startDate.getMonth() === endDate.getMonth()
    ) {
      return `Du ${startDay} au ${endDay} ${startMonthYear}`;
    }

    // Sinon, intervalle complet
    return `Du ${startDay} ${startMonthYear} au ${endDay} ${endMonthYear}`;
  }

}
